(function () {
	if (window.__skuCopyInitialized) return;
	window.__skuCopyInitialized = true;

	document.addEventListener('click', function (event) {
		var button = event.target.closest('[data-copy-sku]');
		if (!button) return;
		var sku = button.getAttribute('data-copy-sku');
		if (!sku) return;

		var copyPromise = navigator.clipboard && navigator.clipboard.writeText
			? navigator.clipboard.writeText(sku)
			: Promise.reject();

		copyPromise.catch(function () {
			var textarea = document.createElement('textarea');
			textarea.value = sku;
			textarea.style.position = 'fixed';
			textarea.style.opacity = '0';
			document.body.appendChild(textarea);
			textarea.select();
			try { document.execCommand('copy'); } catch (e) {}
			document.body.removeChild(textarea);
		}).finally(function () {
			button.classList.add('is-copied');
			window.clearTimeout(button._skuCopyTimeout);
			button._skuCopyTimeout = window.setTimeout(function () {
				button.classList.remove('is-copied');
			}, 1500);
		});
	});
})();
